import type { Palette } from '@mui/material';
import type { TypographyVariantsOptions } from '@mui/material/styles';

export const typography: (palette: Palette) => Readonly<TypographyVariantsOptions> = (palette: Palette) => ({
  allVariants: {
    fontFamily: '"Inter", "Montserrat", sans-serif',
    fontWeight: 500,
    color: palette.text.primary,
  },
  h1: {
    fontSize: '2.25rem',
    fontWeight: 600,
    letterSpacing: '-1.5px',
  },
  h2: {
    fontSize: '1.875rem',
    fontWeight: 600,
    letterSpacing: '-0.5px',
  },
  h3: {
    fontSize: '1.5rem',
    fontWeight: 600,
    letterSpacing: '-0.25px',
  },
  h4: {
    fontSize: '1.25rem',
    fontWeight: 500,
    letterSpacing: '0.25px',
  },
  h5: {
    fontSize: '1.125rem',
    fontWeight: 500,
    letterSpacing: '0',
  },
  h6: {
    fontSize: '1rem',
    fontWeight: 500,
    letterSpacing: '0.15px',
  },
  body1: {
    fontSize: '0.875rem',
    fontWeight: 400,
    letterSpacing: '0.15px',
  },
  body2: {
    fontSize: '0.8125rem',
    fontWeight: 400,
    letterSpacing: '0.17px',
  },
  subtitle1: {
    fontSize: '0.875rem',
    fontWeight: 500,
    letterSpacing: '0.15px',
  },
  subtitle2: {
    fontSize: '0.75rem',
    fontWeight: 500,
    color: palette.text.secondary,
    letterSpacing: '0.1px',
  },
  overline: {
    fontSize: '0.75rem',
    fontWeight: 400,
    textTransform: 'uppercase',
    letterSpacing: '1px',
  },
  caption: { fontSize: '0.75rem', fontWeight: 400, letterSpacing: '0.4px' },
  button: { fontSize: '0.875rem', fontWeight: 500, textTransform: 'none', letterSpacing: '0.2px' },
});
